module.exports = __webpack_public_path__ + "media/images/svg/logos_footer-55069f5ccc0f0f19d1df3a86c0dcbd04.svg";